import { CSSProperties } from "react";

export interface Styles {
  table: CSSProperties;
  headerCell: CSSProperties;
  cell: CSSProperties;
  handle: CSSProperties;
}

const styles: Styles = {
  // Bootstrap's table reads its row divider color from this variable
  table: {
    ["--bs-border-color" as string]: "#eef0f4",
  },
  headerCell: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 13,
    color: "#374151",
    paddingTop: 12,
    paddingBottom: 12,
    whiteSpace: "nowrap",
  },
  cell: {
    fontSize: 13,
    color: "#1A1B22",
    paddingTop: 14,
    paddingBottom: 14,
  },
  handle: {
    width: 32,
    cursor: "grab",
    color: "#9ca3af",
  },
};

export default styles;
